<template>
    <button
        type="button"
        class="menu-item border-0 btn-hover-bg-dark rounded text-white cursor-pointer p-1 text-center mr-2"
        :class="{ 'is-active bg-white': isActive ? isActive(): null }"
        @click="action"
        :title="title"
    >
        <i class="fas" v-if="icon" :class="[icon, active]"></i>
        <span class="font-weight-bold" :class="active" v-else>{{ replaceIcon }}</span>
    </button>
</template>

<script>

export default {
    props: {
        icon: {
            type: String,
        },

        replaceIcon: {
            type: String,
        },

        title: {
            type: String,
        },

        action: {
            type: Function,
        },

        isActive: {
            type: Function,
            default: null,
        },
    },

    computed: {
        active() {
            return {
                'text-primary': this.isActive ? this.isActive() : null
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.menu-item {
    background: transparent;
}
</style>